import { render, staticRenderFns } from "./df-footer.vue?vue&type=template&id=602ccd1e"
import script from "./df-footer.ts?vue&type=script&lang=js&external"
export * from "./df-footer.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports